(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.header');
  if (!header) return;
  // 홈이 아닐 경우 -> 버전2(흰 배경+파란 요소)로 시작
  if (!isHomePage) {
    header.classList.add('scrolled-past-header');
  }
});

document.addEventListener('scroll', function() {
  const header = document.querySelector('.header');
  if (!header) return;

  const announcementBar = document.querySelector('.announcement-bar-section');
  if (!announcementBar) return;

  const announcementHeight = announcementBar.offsetHeight;
  const scrollY = window.scrollY;

  // 비홈 페이지: 항상 버전2, 위치만 동적으로 조정
  if (!isHomePage) {
    if (scrollY < announcementHeight) {
      header.style.top = (announcementHeight - scrollY) + 'px';
    } else {
      header.style.top = '0px';
    }
    return;
  }

  // 홈 페이지: 버전1 -> 스크롤 후 버전2
  if (scrollY >= announcementHeight) {
    header.classList.add('scrolled-past-header');
  } else {
    header.classList.remove('scrolled-past-header');
  }

  if (scrollY < announcementHeight) {
    header.style.top = (announcementHeight - scrollY) + 'px';
  } else {
    header.style.top = '0px';
  }
});

// StickyHeader 클래스에서 비홈 로직 스킵
document.addEventListener('DOMContentLoaded', function() {
  const stickyHeaderElement = document.querySelector('.header-wrapper');
  if (!stickyHeaderElement) return;

  const stickyHeaderType = stickyHeaderElement.getAttribute('data-sticky-type');

  class StickyHeader {
    constructor(element, type) {
      this.element = element;
      this.stickyType = type;
      this.init();
    }
    init() {
      this.header = this.element.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.element.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.element.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.createHeaderObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    createObserver() {
      const observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    createHeaderObserver() {
      window.addEventListener('scroll', () => {
        if (window.pageYOffset > 0) {
          this.header.classList.add('header--bg-light');
        } else {
          this.header.classList.remove('header--bg-light');
        }
      });
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      // 비홈이면 전체 로직 스킵 -> 항상 버전2
      if (!isHomePage) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  new StickyHeader(stickyHeaderElement, stickyHeaderType);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-wedding-gallery"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof GLightbox !== 'undefined') {
      GLightbox({
        selector: '.glightbox'
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
